import Vue from 'vue'
import store from '../store'
import Cookies from 'js-cookie';
// 自定义指令

Vue.directive('has', {
  inserted: function (el, binding) {
    if (!Vue.prototype.$_has(binding.value)) {
      el.parentNode.removeChild(el);
    }
  }
});
//权限检查方法
Vue.prototype.$_has = (value) => {
  let userType = JSON.parse(sessionStorage.getItem("userType"));
  let emums = JSON.parse(sessionStorage.getItem("emums"));
  let permissions = store.state.app.permissions;
  let flag;
  // 是否是超级管理员
  if (userType == emums.userType.superManager) {
    flag = true;
  } else {
    flag = permissions.some(item => {
      return item.mIdentity == value
    });
  }
  return flag;
}
Vue.prototype.$_haves = (value) => {
  let flag
  let userType = JSON.parse(sessionStorage.getItem("userType"));
  let emums = JSON.parse(sessionStorage.getItem("emums"));
  // 是否是超级管理员
  if (userType == emums.userType.superManager) {
    flag = true;
  } else {

    let _isXtAdmin = Vue.prototype.$_isXtAdmin();
    let _isBmAdmin = Vue.prototype.$_isBmAdmin();
    let adminRouterLIst = [];

    // if (_isXtAdmin) {
    //   adminRouterLIst = _isXtAdmin;
    // }

    // if (_isBmAdmin) {
    //   adminRouterLIst = _isBmAdmin;
    // }

    // if (adminRouterLIst.indexOf(value) != -1) {
    //   return true
    // }

    // if (_isXtAdmin || _isBmAdmin) {
    //   return
    // }

    let modelesArr = store.state.app.modelesArr;
    modelesArr.forEach(item => {
      //只判断系统管理里的，因为只有系统管理里面有标签页
      if (item.permission == "system") {
        if(item.children){
          item.children.map((items,indexs)=>{
            if(items.path=="system-deploy"){
              if(items.children){
                // console.log(items.children,value)
                items.children.map((itemc,indexc)=>{
                  if(itemc.permission==value){
                    flag=true
                  }
                })
              }
            }
          })
        }
        // flag = item.permissions.some(item => {
        //   return item.mIdentity == value
        // })
      }
    });

  }

  // console.log(flag)
  return flag;

}
// 判断是否是指定的管理员人员角色
Vue.prototype.$_haveToAdmin = () => {
  // 定义返回数据默认为false
  let flag = false;
  let userType = JSON.parse(sessionStorage.getItem("userType"));
  let emums = JSON.parse(sessionStorage.getItem("emums"));
  // 是否是超级管理员或者系统管理员
  if (userType == emums.userType.superManager || userType == emums.userType.systemManager) {
    flag = true;
  }
  // // 判断是否是超级管理员或者是保密管理员
  // if (Cookies.get('userCount') == 'admin' || Cookies.get('userCount') == 'bmadmin') {
  //   // 返回成功
  //   flag = true;
  // }
  // 返回数据
  return flag;
}

//判断账号是否是管理员站好
Vue.prototype.$_isAdmin = () => {
  let flag = false
  let userType = JSON.parse(sessionStorage.getItem("userType"));
  let emums = JSON.parse(sessionStorage.getItem("emums"));
  // 是否是超级管理员
  if (userType == emums.userType.superManager) {
    flag = true;
  }
  return flag
}

//判断账号是否是xtadmin,并设置路由
Vue.prototype.$_isXtAdmin = () => {
  let flag = false
  let userCode = sessionStorage.getItem("userCode");
  // 是否是系统管理员
  if (userCode == "xtadmin") {
    flag = [
      // 新数据
      "home",
      "system-admin",
      "log-list",
      "tenant-list",
      "system-deploy",
      "user-list"
      // 老数据不用
      // "M_Sys_Admin",
      // "M_LogCenter",
      // "M_TenantList",
      // "M_ParamDeploy",
      // "M_WebSocket",
      // "M_TCP",
      // "M_SerialPortsMan",

      // "M_User",
      // "M_Department",
      // "M_Position",
      // "FLOOR_MANAGE",
      // "system-floor-manage",
      // "M_MeetingRoom",
      // "M_MeetingTemplate",
      // "M_LayoutTemplate",
      // "WORKFLOW_APPROVAL_MANAGE",
      // "M_MeetingNav",
      // "M_ShoutServTypeM",
      // "BASE_DEVICE_LIST",
      // "FONT_MANAGE",
      // "MDM_MANAGE",
      // "INFOMATION_INFOMATION_LIST",
    ]
  }
  return flag
}

//判断账号是否是bmadmin,并设置路由
Vue.prototype.$_isBmAdmin = () => {
  let flag = false
  let userCode = sessionStorage.getItem("userCode");
  // 是否是保密管理员
  if (userCode == "bmadmin") {
    flag = [
      // 新数据
      "home",
      "user-list",
      "log-list",
      "system-power",
      // 老数据不用
      // "M_User",
      // "M_LogCenter ",
      // "M_Authority_role ",
      // "M_Authority_Per",
      // "M_Authori_Module",
    ];
  }
  return flag
}

//判断账号是否是sjadmin,并设置路由
Vue.prototype.$_isSjAdmin = () => {
  let flag = false
  let userCode = sessionStorage.getItem("userCode");
  // 是否是检查管理员
  if (userCode == "sjadmin") {
    flag = [
      "home",
      "log-list",
      // "M_LogCenter"
    ];
  }
  return flag
}

//判断账号是否是会务人员、部门管理员、会议秘书、借阅管理人员
Vue.prototype.$_isSpecialRole = () => {
  let roles = {
    // 会务人员
    CONFERENCE_COORDINATOR: false,
    // 部门管理员
    DEPT_ADMIN: false,
    // 会议秘书
    CONFERENCE_SECRETARY: false,
    // 借阅管理人员
    BORROWING_COORDINATOR: false,
  }

  let modelesArr = JSON.parse(localStorage.getItem("modelesArr"));
  let emums = JSON.parse(sessionStorage.getItem("emums"));

  let userType = JSON.parse(sessionStorage.getItem("userType"));
  // 是否是超级管理员
  if (userType == emums.userType.superManager) {
    return {
      // 会务人员
      CONFERENCE_COORDINATOR: true,
      // 部门管理员
      DEPT_ADMIN: true,
      // 会议秘书
      CONFERENCE_SECRETARY: true,
      // 借阅管理人员
      BORROWING_COORDINATOR: true,
    }
  }

  let userRole = emums.userRole;
  // 根据角色菜单判断是否有某权限
  modelesArr.map((item) => {
    if (item.children) {
      item.children.map((item) => {
        switch (item.permission) {
          // 会务人员
          case userRole.CONFERENCE_COORDINATOR:
            roles.CONFERENCE_COORDINATOR = true;
            return
          // 部门管理员
          case userRole.DEPT_ADMIN:
            roles.DEPT_ADMIN = true;
            return
          // 会议秘书
          case userRole.CONFERENCE_SECRETARY:
            roles.CONFERENCE_SECRETARY = true;
            return
          // 借阅管理人员
          case userRole.BORROWING_COORDINATOR:
            roles.BORROWING_COORDINATOR = true;
            return

          default:
            break;
        }
      })
    }
  })

  return roles
}




// WEBPACK FOOTER //
// ./src/directive/directive.js